import PropTypes from 'prop-types';
import React, { useState } from 'react';
import Modal from '../Modal/Modal';
import styles from './HeroButtonModal.module.scss';
import classNames from 'classnames';
import Image from '../Image';
import Tag from '../Tag';
import RawHtml from '../RawHtml';
import { ucFirst } from '../../utils/caseconverters';

const HeroButtonModal = ({
    title = '',
    text = '',
    modal = {},
    image,
    tags,
    children,
    modifiers = [],
    onLinkClick,
    onClick
}) => {
    const [hasLoadedImage, setHasLoadedImage] = useState(false);

    const imageClasses = classNames(styles['HeroButtonModal__Image'], {
        [styles['HeroButtonModal__Image--Loaded']]: hasLoadedImage,
    });

    const classes = classNames(
        styles['HeroButtonModal'],
        modifiers.map(
            (modifier) => styles['HeroButtonModal--' + ucFirst(modifier)] + ' '
        )
    );    

    return (
        <div className={classes}>
            <div className={styles['HeroButtonModal__Container']}>
                <div className={styles['HeroButtonModal__Content']}>
                    <div className={styles['HeroButtonModal__TextWrapper']}>
                        <div
                            className={styles['HeroButtonModal__TitleWrapper']}>
                            {tags?.map((tag, index) => (
                                <Tag key={index} {...tag} />
                            ))}
                            <h1 className={styles['HeroButtonModal__Title']}>
                                {title}
                            </h1>
                        </div>
                        <p className={styles['HeroButtonModal__Text']}>
                            {text}
                        </p>
                    </div>
                    <div className={styles['HeroButtonModal__ButtonWrapper']}>
                        {modal && (
                            <Modal {...modal} onClick={onClick} buttonText="Download" ariaLabel={modal.buttonText}>
                                {children ? (
                                    children
                                ) : (
                                    <RawHtml html={modal.content} onLinkClick={onLinkClick}/>
                                )}
                            </Modal>
                        )}
                    </div>
                </div>
                {image && (
                    <div className={styles['HeroButtonModal__ImageWrapper']}>
                        <Image
                            {...image}
                            className={imageClasses}
                            layout="fill"
                            objectFit="contain"
                            priority={true}
                            onLoadingComplete={() => setHasLoadedImage(true)}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

HeroButtonModal.propTypes = {
    title: PropTypes.string,
    text: PropTypes.string,
    modal: PropTypes.object,
    image: PropTypes.object,
    tags: PropTypes.array,
};

export default HeroButtonModal;
